export const euro    = require('./keg-euro.png?sizes=800w+400w+200w+100w+default');
export const us30    = require('./keg-us-30.png?sizes=800w+400w+200w+100w+default');
export const us50    = require('./keg-us-50.png?sizes=800w+400w+200w+100w+default');
export const generic = require('./keg.png?sizes=800w+400w+200w+100w+default');
